import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './EmailModal.css';
import FormModal from 'components/shared/modal/FormModal';
import Button from 'components/shared/button/Button';
import { EmailEditor } from 'components/shared/email/EmailEditor';

export class EmailModal extends Component {
  static propTypes = {
    defaultEmails: PropTypes.arrayOf(PropTypes.string),
    defaultMessage: PropTypes.string,
    defaultSubject: PropTypes.string,
    emails: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string.isRequired,
    show: PropTypes.bool,
    onClose: PropTypes.func,
    onSend: PropTypes.func,
  };

  static defaultProps = {
    defaultEmails: [],
    defaultMessage: '',
    defaultSubject: '',
    emails: [],
    show: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      message: props.defaultMessage,
      subject: props.defaultSubject,
      toEmails: props.defaultEmails,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.defaultSubject !== this.state.subject) {
      this.setState({
        subject: nextProps.defaultSubject,
      });
    }
    if (nextProps.defaultMessage !== this.state.message) {
      this.setState({
        message: nextProps.defaultMessage,
      });
    }
    this.setState({
      toEmails: nextProps.defaultEmails,
    });
  }

  handleAddCustomEmail = (email) => {
    this.setState({
      toEmails: this.state.toEmails.concat([email]),
    });
  };

  handleAddUserEmail = (email) => {
    this.setState({
      toEmails: this.state.toEmails.concat([email]),
    });
  };

  handleClose = (event) => {
    event.preventDefault();
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleMessageChange = (message) => {
    this.setState({
      message: message,
    });
  };

  handleSend = () => {
    if (this.props.onSend) {
      this.props.onSend(
        this.state.toEmails,
        this.state.subject,
        this.state.message
      );
    }
  };

  handleSubjectConfirm = (subject) => {
    this.setState({
      subject: subject,
    });
  };

  handleToEmailRemove = (email) => {
    this.setState({
      toEmails: this.state.toEmails.filter((toEmail) => toEmail !== email),
    });
  };

  isSendButtonEnabled = () => {
    return (
      this.state.toEmails.length > 0 &&
      this.state.subject !== '' &&
      this.state.message !== ''
    );
  };

  render() {
    return this.props.show ? (
      <FormModal
        className="email-modal"
        show={this.props.show}
        title={this.props.title}
        onClose={this.handleClose}
      >
        <div className="email-container">
          <EmailEditor
            toEmails={this.state.toEmails}
            message={this.state.message}
            subject={this.state.subject}
            usersEmail={this.props.emails}
            onCustomEmailAdd={this.handleAddCustomEmail}
            onMessageChange={this.handleMessageChange}
            onSubjectConfirm={this.handleSubjectConfirm}
            onToEmailRemove={this.handleToEmailRemove}
            onUserEmailAdd={this.handleAddUserEmail}
          />

          <div className="button-container">
            <Button
              className="button-orange"
              disabled={!this.isSendButtonEnabled()}
              label="Send"
              onClick={this.handleSend}
            />
          </div>
        </div>
      </FormModal>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/email/EmailModal.js